/**
 * Order Tracking Section JavaScript
 * Handles 17track widget initialization and Shopify editor integration
 */

(function () {
  /**
   * Track a package using 17track
   * @param {string} sectionId - The section ID
   * @param {string} trackingNum - The tracking number
   */
  window.trackWith17Track = function (sectionId, trackingNum) {
    const section = document.querySelector('.order-tracking--' + sectionId);
    if (!section) return;

    const method = section.dataset.trackingMethod || 'embed';
    const widgetHeight = parseInt(section.dataset.widgetHeight, 10) || 560;
    const lang = section.dataset.lang || 'en';
    const trackingUrl = 'https://t.17track.net/' + encodeURIComponent(lang) + '#nums=' + encodeURIComponent(trackingNum);

    function openTrackingInNewTab() {
      const trackingWindow = window.open(trackingUrl, '_blank', 'noopener,noreferrer');
      if (trackingWindow) {
        trackingWindow.opener = null;
      }
    }

    if (method === 'new_tab') {
      openTrackingInNewTab();
      return;
    }

    // Embed method - use section-specific 17track container ID
    const containerId = section.dataset.widgetContainerId || 'YQContainer-' + sectionId;
    const container = document.getElementById(containerId);
    if (!container) {
      // Fallback to new tab if container doesn't exist
      openTrackingInNewTab();
      return;
    }

    // Show loading state
    container.innerHTML = '<p class="order-tracking__loading">Loading tracking info...</p>';

    // Wait for 17track script and initialize widget
    var attempts = 0;
    var maxAttempts = 50;

    function initWidget() {
      attempts++;
      if (typeof YQV5 !== 'undefined') {
        container.innerHTML = '';
        YQV5.trackSingle({
          YQ_ContainerId: containerId,
          YQ_Height: widgetHeight,
          YQ_Fc: '0',
          YQ_Lang: lang,
          YQ_Num: trackingNum
        });
      } else if (attempts < maxAttempts) {
        setTimeout(initWidget, 100);
      } else {
        // Fallback: open in new tab if script fails to load
        openTrackingInNewTab();
        container.innerHTML = '';
      }
    }

    initWidget();
  };

  /**
   * Initialize section for Shopify editor
   */
  function initOrderTrackingSection(sectionId) {
    var section = document.querySelector('.order-tracking--' + sectionId);
    if (!section) return;

    if (typeof Alpine !== 'undefined' && !section._x_dataStack) {
      Alpine.initTree(section);
    }
  }

  // Shopify editor events
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-id]');
    if (section && section.closest('.order-tracking')) {
      initOrderTrackingSection(section.getAttribute('data-section-id'));
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    var section = event.target.querySelector('[data-section-id]');
    if (section && section.closest('.order-tracking')) {
      initOrderTrackingSection(section.getAttribute('data-section-id'));
    }
  });
})();
